import React, { useState } from "react";
import { Box } from "@mui/material";
import { Outlet } from "react-router-dom";
import SuperAdminHeader from "./Header";
import SuperAdminSidebar from "./Sidebar";

const DRAWER_WIDTH = 0;
const MINI_WIDTH = 0;

export default function SuperAdminLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(() => {
    try {
      return localStorage.getItem("super_sidebar_open") !== "0";
    } catch {
      return true;
    }
  });

  const toggleSidebar = () => {
    setSidebarOpen((s) => {
      const next = !s;
      try {
        localStorage.setItem("super_sidebar_open", next ? "1" : "0");
      } catch {}
      return next;
    });
  };

  return (
    <Box
      sx={{
        display: "flex",
        minHeight: "100vh",
        background:
          "radial-gradient(circle at 90% 12%, rgba(8,145,178,0.12), transparent 25%), radial-gradient(circle at 18% 76%, rgba(37,99,235,0.08), transparent 28%), linear-gradient(135deg, #f7fafc 0%, #eef3f8 48%, #e5f5f2 100%)",
      }}
    >
      <SuperAdminHeader onToggle={toggleSidebar} />
      <SuperAdminSidebar open={sidebarOpen} setOpen={setSidebarOpen} />
      <Box
        component="main"
        sx={{
          flexGrow: 1,
          mt: "78px",
          ml: sidebarOpen ? `${DRAWER_WIDTH}px` : `${MINI_WIDTH}px`,
          transition: "margin 0.3s ease",
          p: { xs: 1.5, md: 2.5 },
          minWidth: 0,
          minHeight: "calc(100vh - 70px)",
        }}
      >
        <Outlet />
      </Box>
    </Box>
  );
}
